import { Checkbox, Form, Input, InputNumber } from "antd";
import React, { Component } from "react";
import DateTimePicker from "./DateTimePicker";
import GenericFromToDatePicker from "./GenericFromToDatePicker";
import GenericSelector from "./GenericSelector";
import GenericSelectorPosStorages from "./GenericSelectorPosStorages";
import GenericSelectorCustTags from "./GenericSelectorCustTags";


class GenericFormItem extends Component {

    getContent = () => {
        const { value, onChange, inputType, inputProps, label } = this.props
        switch (inputType) {
            case "text": return (<Input value={value} onChange={e => { onChange(e.target.value) }} {...inputProps} />)
            case "textarea": return (<Input.TextArea value={value} onChange={e => { onChange(e.target.value) }} {...inputProps} />)
            case "number": return (<InputNumber value={value} onChange={onChange} {...inputProps} />)
            case "checkbox": return (<Checkbox checked={value == '1'} onChange={e => { onChange(e.target.checked ? "1" : "0") }} {...inputProps}>{label}</Checkbox>)
            case "date": return (<DateTimePicker format={"DD/MM/YYYY"} value={value} onChange={onChange} {...inputProps} />)
            case "time": return (<DateTimePicker format={"HH:mm"} showTime value={value} onChange={onChange} {...inputProps} />)
            case "datetime": return (<DateTimePicker format={"DD/MM/YYYY HH:mm"} showTime value={value} onChange={onChange} {...inputProps} />)
            case "dateFromTo": return (<GenericFromToDatePicker format={"DD/MM/YYYY"} {...inputProps} />)
            case "daysOfWeek": return this.getDaysOfWeek()
            case "selector": return (<GenericSelector value={value} onChange={onChange} {...inputProps} />)
            case "posSelector": return (<GenericSelectorPosStorages value={value} onChange={onChange} {...inputProps} />)
            case "custTagSelector": return (<GenericSelectorCustTags value={value} onChange={onChange} {...inputProps} />)
        }
    }

    getDaysOfWeek = () => {
        const { value, onChange } = this.props
        const val = value ? value.split(',') : []
        let weekData = 'אבגדהוז'.split('').map((x, i) => {
            return { name: x, value: ''+(i + 1), checked: val.find(f => f == (i + 1)) ? true : false }
        })
        return weekData.map((x, i) => {
            return (<Checkbox
            style={{marginLeft:25}}
                checked={x.checked}
                onChange={e => {

                    let toUpdate = [...weekData]
                    toUpdate[i].checked = e.target.checked
                    onChange(toUpdate.filter(f => f.checked).map(y => y.value).join(","))

                }}>{x.name}</Checkbox>)
        })
    }

    render() {

        let formItemProps = { label: this.props.inputType != "checkbox" ? this.props.label : null }
        if (this.props.formItemProps) formItemProps = { ...formItemProps, ...this.props.formItemProps }
        if (this.props.isMandatory) formItemProps = { ...formItemProps, required: true, validateStatus: !this.props.value ? "error" : "success" }

        return (<Form.Item {...formItemProps}>{this.getContent()}</Form.Item>)
    }
}

export default GenericFormItem;